<div class="row insight-info-bar {{ getSeverity() }}" *ngIf="caption">
  <label style="margin-left: 4px; font-weight: 400;color: white">
    {{ captionPrefix }}
  </label>
  <label style="font-weight: bold;color: white;white-space: pre">
    {{ ' ' + getSeverityCaption() + ' ' }}
  </label>
  <label style="font-weight: 400;color: white">{{ caption }}</label>
</div>
